import React, { MouseEvent, useState } from "react";
import { Clipboard, ClipboardCheck } from "lucide-react";
import { Button } from "../ui/button";

const CopyButton = ({ textToCopy }: { textToCopy: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: MouseEvent) => {
    // Prevent the click event from propagating to the parent Link
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);

      // Reset the copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy text: ", error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <Button
        onClick={handleCopy}
        variant={"outline"}
        // variant={"secondary"}
        // className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
      >
        {copied ? (
          <>
            <ClipboardCheck size={20} />
            {/* <span>Copied!</span> */}
          </>
        ) : (
          <>
            <Clipboard size={20} />
            {/* <span>Copy</span> */}
          </>
        )}
      </Button>

      {copied ? (
        <span className="mt-2 text-sm">Copied!</span>
      ) : (
        <span className="mt-2 text-sm">Copy</span>
      )}
    </div>
  );
};

export default CopyButton;
